/**
 * Created by FLI on 2015-01-24.
 */

//Lazyload child controller
angular.module('ffApp').controller('PodcastArchiveController', ['$scope', '$rootScope', '$http', '$sce', function( $scope, $rootScope, $http, $sce )
{
	$scope.podcasts = [];

	if( typeof window.lazyLoad.podcastReset == "undefined" || window.lazyLoad.podcastReset == false ) {
		jQuery(window).on('ngPageLoadSuccess', function(){

		});
		window.lazyLoad.podcastReset = true;
	}

	$scope.init = function() {
		$scope.podcasts = window.preload_podcasts;
	};

	/**
	 * Make a HTML string trusted
	 *
	 * @param html
	 * @returns {*}
	 */
	$scope.trustHtml = function(html)
	{
		return $sce.trustAsHtml(html);
	};

	$scope.$watch(function()
	{
		return window.preload_podcasts;
	}, function(newVal, oldVal)
	{
		$scope.podcasts = window.preload_podcasts;
	});

	$scope.$on('queryThresholdElement', function(event)
	{
		var podcast_list = jQuery(".podcast-list");
		$scope.$parent.thresholdElement = podcast_list.children("article").last();
		$scope.$parent.offset = podcast_list.children("article").last().find('.holder').data('offset');
	});

	$rootScope.$on('playPodcast', function(event, postId)
	{
		jQuery('.podcast-list').children().removeClass('is-active');
		jQuery('.podcast-post-id-'+postId).parent().addClass('is-active');
	});

	$scope.$on('loadPosts', function( event, offset )
	{
		$scope.$parent.insertLoaderHTML('.podcast-list', ___('Loading more podcasts...', 'Laddar fler podcasts...'), 'pod');

		var lang = jQuery(".podcast-list").data("language") || 'all';
		var count = 5;
		offset = parseInt(offset) + 1;

		var endpoint = apiUrl + "podcasts/offset/" + offset + "/count/" + count + "/lang/" + lang;

		$http.get( endpoint ).
			then(function(response) {
				var data = response.data;
				if (data == null || data.length == 0) {
					//No more podcasts
					jQuery(".loader.pod").html("<span class='red'>"+___('No more podcasts found!', 'Hittade inte fler podcasts!')+"</span>").fadeOut(1000, function () {
						jQuery(this).remove();
					});
				}
				else {
					$scope.$parent.removeLoaderHTML('.podcast-list');

					jQuery(data).each(function (i, v) {
						var o = offset + i;

						var item = {
							offset: o,
							thumbnail: v.thumbnail,
							date: v.date,
							title: v.title,
							url: v.url,
							permalink: v.permalink,
							post_id: v.post_id
						}
						$scope.podcasts.push(item);

					});

					$scope.$parent.thresholdElement = null; //This will update automatically through broadcasted event
					$scope.$parent.loaderTriggered = false;
				}
			}, function(response) {
				var status = response.status;
				if( console && typeof console.error == 'function' ) {
					console.error(status);
				}
			});
	});
}]);